// extracted by mini-css-extract-plugin
module.exports = {"container":"_6c97079b1b--container--1NRW-","mobile":"_6c97079b1b--mobile--2kkXM","submit":"_6c97079b1b--submit--3hb6Z","info":"_6c97079b1b--info--GBiax"};